import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-close",
  "use": "icon-close-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-close\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M4 4h16v16H4z\" /><path d=\"M0 0h24v24H0z\" /><g fill=\"currentColor\" fill-rule=\"nonzero\"><path d=\"m18.364 4.222 1.414 1.414L5.636 19.778l-1.414-1.414z\" /><path d=\"m19.778 18.364-1.414 1.414L4.222 5.636l1.414-1.414z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol